<template>
	<span :style="iconStyle" class="my-icon" @click="$emit('click', $event)" @mousedown="$emit('mousedown', $event)">
		<i :key="index" :class="item" :style="icon | setViewStyle(size, color, index)" v-for="(item, index) in classList"></i>
	</span>
</template>

<script>
	export default {
		name: 'my-icon',
		props: {
			icon: {
				type: String,
				default: 'menu',
				validator: value => ['up', 'down', 'left', 'play', 'plus', 'menu', 'minus', 'pause', 'close', 'right', 'login', 'burger', 'avatar', 'replay', 'refresh', 'up-arrow', 'down-arrow', 'left-arrow', 'right-arrow', 'up-return', 'down-return', 'left-return', 'right-return'].indexOf(value) > -1
			},
			size: {
				type: String,
				default: '30px'
			},
			color: {
				type: String,
				default: '#FFFFFF'
			},
			absolute: {
				type: Boolean,
				default: false
			},
			customClass: {
				type: String,
				default: ''
			}
		},
        filters: {
            setViewStyle(icon, size, color, index) {
                if (['replay', 'refresh'].indexOf(icon) > -1) {
                    if (index === 0) {
                        return `border-color: ${color};border-width: calc(${size} / 15);background-color: transparent;`;
                    }
                }
                if (['avatar'].indexOf(icon) > -1) {
                    return `border-color: ${color};border-width: calc(${size} / 15);background-color: transparent;`;
                }
                return `border-color: ${color};background-color: ${color};`;
            }
        },
		computed: {
			iconStyle() {
				return `width: ${this.size};height: ${this.size};position: ${this.absolute ? 'absolute' : 'relative'};`;
			},
			classList() {
				const list = [];
				const data = {
					'up': 1,
					'down': 1,
					'left': 1,
					'play': 1,
                    'plus': 1,
					'menu': 1,
                    'minus': 1,
					'close': 1,
					'right': 1,
					'pause': 1,
                    'login': 1,
                    'burger': 1,
                    'avatar': 2,
                    'replay': 2,
                    'refresh': 2,
					'up-arrow': 1,
					'down-arrow': 1,
					'left-arrow': 1,
					'right-arrow': 1,
					'up-return': 1,
					'down-return': 1,
					'left-return': 1,
					'right-return': 1
				};
				for (let i = 1; i <= data[this.icon]; i++) {
					list.push(`my-icon-view icon-${this.icon}-${i} ${this.customClass}`);
				}
				return list;
			}
		}
	}
</script>

<style scoped lang="less">
	.my-icon{
		display: inline-flex;
		position: relative;
		cursor: pointer;
		.my-icon-view{
			position: absolute;
			transition: all 100ms linear;
            // -webkit-clip-path: polygon();
            // clip-path: polygon();
		}
		.icon-up-1, .icon-down-1, .icon-left-1, .icon-right-1, .icon-up-arrow-1, .icon-down-arrow-1, .icon-left-arrow-1, .icon-right-arrow-1, .icon-up-return-1, .icon-down-return-1, .icon-left-return-1, .icon-right-return-1{
            width: 100%;
            height: 100%;
        }
		.icon-up-1, .icon-down-1, .icon-left-1, .icon-right-1{
            -webkit-clip-path: polygon(22% 73%, 22% 63%, 50% 27%, 78% 63%, 78% 73%, 50% 37%);
            clip-path: polygon(22% 73%, 22% 63%, 50% 27%, 78% 63%, 78% 73%, 50% 37%);
        }
		.icon-up-arrow-1, .icon-down-arrow-1, .icon-left-arrow-1, .icon-right-arrow-1{
            -webkit-clip-path: polygon(22% 63%, 22% 53%, 50% 27%, 78% 53%, 78% 63%, 54% 41%, 54% 73%, 46% 73%, 46% 41%);
            clip-path: polygon(22% 63%, 22% 53%, 50% 27%, 78% 53%, 78% 63%, 54% 41%, 54% 73%, 46% 73%, 46% 41%);
        }
		.icon-up-return-1, .icon-down-return-1, .icon-left-return-1, .icon-right-return-1{
            -webkit-clip-path: polygon(25% 58%, 25% 48%, 50% 27%, 75% 48%, 75% 58%, 50% 37%, 25% 58%, 25% 68%, 25% 78%, 50% 57%, 75% 78%, 75% 68%, 50% 47%, 25% 68%);
            clip-path: polygon(25% 58%, 25% 48%, 50% 27%, 75% 48%, 75% 58%, 50% 37%, 25% 58%, 25% 68%, 25% 78%, 50% 57%, 75% 78%, 75% 68%, 50% 47%, 25% 68%);
        }
		// up 向上按钮、向上箭头按钮、返回顶部
		.icon-up-1, .icon-up-arrow-1, .icon-up-return-1{
            transform: rotate(0deg);
        }
		// down 向下按钮、向下箭头按钮、返回底部
		.icon-down-1, .icon-down-arrow-1, .icon-down-return-1{
            transform: rotate(180deg);
        }
		// left 向左按钮、向左箭头按钮、返回第一页
		.icon-left-1, .icon-left-arrow-1, .icon-left-return-1{
            transform: rotate(270deg);
        }
		// right 向右按钮、向右箭头按钮、返回最后一页
		.icon-right-1, .icon-right-arrow-1, .icon-right-return-1{
            transform: rotate(90deg);
        }
		.icon-play-1, .icon-pause-1, .icon-login-1, .icon-menu-1, .icon-plus-1, .icon-minus-1, .icon-close-1, .icon-burger-1{
			top: 50%;
			left: 50%;
            width: 60%;
            height: 60%;
			transform: translate(-50%, -50%);
        }
		// play 播放按钮
		.icon-play-1{
            -webkit-clip-path: polygon(0 0, 0 25%, 0 50%, 0 75%, 0 100%, 33% 83.5%, 67% 66.5%, 100% 50%, 67% 33.5%, 33% 16.5%);
            clip-path: polygon(0 0, 0 25%, 0 50%, 0 75%, 0 100%, 33% 83.5%, 67% 66.5%, 100% 50%, 67% 33.5%, 33% 16.5%);
        }
		// pause 暂停按钮
		.icon-pause-1{
            -webkit-clip-path: polygon(33% 0, 0 0, 0 100%, 33% 100%, 33% 0, 67% 0, 100% 0, 100% 100%, 67% 100%, 67% 0);
            clip-path: polygon(33% 0, 0 0, 0 100%, 33% 100%, 33% 0, 67% 0, 100% 0, 100% 100%, 67% 100%, 67% 0);
        }
        // login 登录按钮
        .icon-login-1{
            -webkit-clip-path: polygon(30% 30%, 30% 0, 100% 0, 100% 100%, 30% 100%, 30% 70%, 40% 70%, 40% 90%, 90% 90%, 90% 10%, 40% 10%, 40% 30%, 30% 30%, 0 45%, 0 55%, 65% 55%, 50% 68%, 50% 80%, 85% 50%, 50% 20%, 50% 32%, 65% 45%, 0 45%);
            clip-path: polygon(30% 30%, 30% 0, 100% 0, 100% 100%, 30% 100%, 30% 70%, 40% 70%, 40% 90%, 90% 90%, 90% 10%, 40% 10%, 40% 30%, 30% 30%, 0 45%, 0 55%, 65% 55%, 50% 68%, 50% 80%, 85% 50%, 50% 20%, 50% 32%, 65% 45%, 0 45%);
        }
		// menu 菜单按钮
		.icon-menu-1{
            -webkit-clip-path: polygon(50% 50%, 43% 43%, 43% 0, 0 0, 0 43%, 43% 43%, 50% 50%, 43% 57%, 43% 100%, 0 100%, 0 57%, 43% 57%, 50% 50%, 57% 57%, 100% 57%, 100% 100%, 57% 100%, 57% 57%, 50% 50%, 57% 43%, 100% 43%, 100% 0, 57% 0, 57% 43%, 50% 50%);
            clip-path: polygon(50% 50%, 43% 43%, 43% 0, 0 0, 0 43%, 43% 43%, 50% 50%, 43% 57%, 43% 100%, 0 100%, 0 57%, 43% 57%, 50% 50%, 57% 57%, 100% 57%, 100% 100%, 57% 100%, 57% 57%, 50% 50%, 57% 43%, 100% 43%, 100% 0, 57% 0, 57% 43%, 50% 50%);
        }
        // plus 加
        .icon-plus-1{
            -webkit-clip-path: polygon(0 57%, 0 50%, 0 43%, 22% 43%, 43% 43%, 43% 22%, 43% 0, 50% 0, 57% 0, 57% 22%, 57% 43%, 78% 43%, 100% 43%, 100% 50%, 100% 57%, 78% 57%, 57% 57%, 57% 78%, 57% 100%, 50% 100%, 43% 100%, 43% 78%, 43% 57%, 22% 57%, 0 57%);
            clip-path: polygon(0 57%, 0 50%, 0 43%, 22% 43%, 43% 43%, 43% 22%, 43% 0, 50% 0, 57% 0, 57% 22%, 57% 43%, 78% 43%, 100% 43%, 100% 50%, 100% 57%, 78% 57%, 57% 57%, 57% 78%, 57% 100%, 50% 100%, 43% 100%, 43% 78%, 43% 57%, 22% 57%, 0 57%);
        }
        // minus 减
        .icon-minus-1{
            -webkit-clip-path: polygon(0 50%, 0 43%, 10% 43%, 20% 43%, 30% 43%, 40% 43%, 50% 43%, 60% 43%, 70% 43%, 80% 43%, 90% 43%, 100% 43%, 100% 50%, 100% 57%, 90% 57%, 80% 57%, 70% 57%, 60% 57%, 50% 57%, 40% 57%, 30% 57%, 20% 57%, 10% 57%, 0 57%, 0 50%);
            clip-path: polygon(0 50%, 0 43%, 10% 43%, 20% 43%, 30% 43%, 40% 43%, 50% 43%, 60% 43%, 70% 43%, 80% 43%, 90% 43%, 100% 43%, 100% 50%, 100% 57%, 90% 57%, 80% 57%, 70% 57%, 60% 57%, 50% 57%, 40% 57%, 30% 57%, 20% 57%, 10% 57%, 0 57%, 0 50%);
        }
		// close 关闭按钮
		.icon-close-1{
            -webkit-clip-path: polygon(0 10%, 5% 5%, 10% 0, 30% 20%, 50% 40%, 70% 20%, 90% 0, 95% 5%, 100% 10%, 80% 30%, 60% 50%, 80% 70%, 100% 90%, 95% 95%, 90% 100%, 70% 80%, 50% 60%, 30% 80%, 10% 100%, 5% 95%, 0 90%, 20% 70%, 40% 50%, 20% 30%, 0 10%);
            clip-path: polygon(0 10%, 5% 5%, 10% 0, 30% 20%, 50% 40%, 70% 20%, 90% 0, 95% 5%, 100% 10%, 80% 30%, 60% 50%, 80% 70%, 100% 90%, 95% 95%, 90% 100%, 70% 80%, 50% 60%, 30% 80%, 10% 100%, 5% 95%, 0 90%, 20% 70%, 40% 50%, 20% 30%, 0 10%);
        }
        // burger 汉堡包菜单
        .icon-burger-1{
            -webkit-clip-path: polygon(0 14%, 0 0, 50% 0, 100% 0, 100% 14%, 50% 14%, 0 14%, 0 43%, 33% 43%, 67% 43%, 100% 43%, 100% 50%, 100% 57%, 67% 57%, 33% 57%, 0 57%, 0 50%, 0 43%, 0 86%, 50% 86%, 100% 86%, 100% 100%, 50% 100%, 0 100%, 0 86%);
            clip-path: polygon(0 14%, 0 0, 50% 0, 100% 0, 100% 14%, 50% 14%, 0 14%, 0 43%, 33% 43%, 67% 43%, 100% 43%, 100% 50%, 100% 57%, 67% 57%, 33% 57%, 0 57%, 0 50%, 0 43%, 0 86%, 50% 86%, 100% 86%, 100% 100%, 50% 100%, 0 100%, 0 86%);
        }
        // avatar 头像
        .icon-avatar-1, .icon-avatar-2{
            left: 50%;
            height: 33%;
            border-style: solid;
            box-sizing: border-box;
            transform: translateX(-50%);
        }
        .icon-avatar-1{
            width: 33%;
            bottom: 48%;
            border-radius: 50%;
        }
        .icon-avatar-2{
            top: 46%;
            width: 55%;
            border-radius: 50% 50% 0 0;
        }
        // replay 重新播放按钮 refresh 刷新按钮
        .icon-replay-1, .icon-replay-2, .icon-refresh-1, .icon-refresh-2{
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
        }
        .icon-replay-1, .icon-refresh-1{
            width: 60%;
            height: 60%;
            border-radius: 50%;
            border-style: solid;
            box-sizing: border-box;
            -webkit-clip-path: polygon(50% 25%, 100% 25%, 100% 0, 0 0, 0 100%, 100% 100%, 100% 50%, 50% 50%);
            clip-path: polygon(50% 25%, 100% 25%, 100% 0, 0 0, 0 100%, 100% 100%, 100% 50%, 50% 50%);
        }
        .icon-replay-2, .icon-refresh-2{
            width: 100%;
            height: 100%;
        }
        .icon-replay-2{
            -webkit-clip-path: polygon(58% 38%, 78% 38%, 72% 17%, 58% 38%, 42.5% 40%, 42.5% 60%, 62.5% 50%, 42.5% 40%);
            clip-path: polygon(58% 38%, 78% 38%, 72% 17%, 58% 38%, 42.5% 40%, 42.5% 60%, 62.5% 50%, 42.5% 40%);
        }
        .icon-refresh-2{
            -webkit-clip-path: polygon(58% 38%, 78% 38%, 72% 17%, 58% 38%);
            clip-path: polygon(58% 38%, 78% 38%, 72% 17%, 58% 38%);
        }
	}
</style>